var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ad"},[_c('Adsense',{attrs:{"root-class":"page-adswrapper","ins-class":"imgbayes_220310_1","data-ad-client":"ca-pub-9629400062449510","data-ad-slot":"1192632324","ins-style":"display:inline-block;width:100%;height:100%;","data-full-width-responsive":"true"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0653460e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/components/GoogleAdsense/index.vue
// module id = null
// module chunks = 